module.exports = __webpack_public_path__ + "img/register.7a5fda33.png";